<template>
  <a-spin :spinning="loading">
    <a-alert banner :show-icon="false" v-if="matchInfo.signCostStatus !== ''">
      <span slot="message">{{ getPayType() }}<a-icon type="question-circle" style="margin-left: 10px;" @click="showModelData()"/></span>
    </a-alert>
    <a-alert type="success" v-if="signUpData == null">
      <a-empty :image="emptyUser" slot="message">
        <div style="text-align: center; color: gray;" slot="description"> 暂无已报名的队员信息 </div>
      </a-empty>
    </a-alert>
    <a-collapse v-if="signUpData != null">
      <a-collapse-panel v-for="(group, gIndex) in signUpData.groups" :key="'group' + gIndex">
        <div slot="header" class="header">
          <div class="team">
            <span class="teamName">{{ group.name }}</span>
          </div>
          <div class="teamData">
            <a-tag color="#2db7f5">参赛人数：{{ group.playerNumber }}人</a-tag>
            <a-tag :color="matchInfo.signCostStatus === 'FREE' ? '#87d068' : (unPayPlayerNumInGroup(group) === 0 ? '#87d068' : '#f50')">{{ matchInfo.signCostStatus === 'FREE' ? '免报名费' : (unPayPlayerNumInGroup(group) === 0 ? '已缴费' : '未缴费：' + unPayPlayerNumInGroup(group) + '人') }}</a-tag>
          </div>
        </div>
        <a-collapse>
          <a-collapse-panel v-for="(combat, cIndex) in group.combats" :key="'combat' + cIndex">
            <div slot="header" class="header">
              <div class="team">
                <span class="teamName">{{ combat.fullName }}</span>
              </div>
              <div class="teamData">
                <a-tag color="#108ee9">参赛人数：{{ combat.players.length }}人</a-tag>
                <a-tag :color="matchInfo.signCostStatus === 'FREE' ? '#87d068' : (unPayPlayerNumInTeam(combat) === 0 ? '#87d068' : '#f50')">{{ matchInfo.signCostStatus === 'FREE' ? '免报名费' : (unPayPlayerNumInTeam(combat) === 0 ? '已缴费' : '未缴费：' + unPayPlayerNumInTeam(combat) + '人') }}</a-tag>
              </div>
            </div>
            <a-table
              :columns="combat.identity > 2 ? teamCombatColumns : singleCombatColumns"
              :data-source="combat.players"
              size="small"
              :pagination="false">
              <div class="player" slot="name" slot-scope="text, record">
                <img :src="record.head || defaultHead"/>
                <span>{{ record.name }}</span>
              </div>
              <span slot="teamNumber" slot-scope="text">{{ text + '队' }}</span>
              <a-tag :color="text == 1 ? '#87d068' : '#f50'" slot="signStatus" slot-scope="text">{{ matchInfo.signCostStatus === 'FREE' ? '免报名费' : (text === 1 ? '已购买' : '未购买') }}</a-tag>
              <div slot="action" slot-scope="text, record, index">
                <a-popconfirm
                  title="确定要删除该条参赛信息?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="delPlayer(combat, record, index, cIndex, gIndex)">
                  <a-button size="small">删除</a-button>
                </a-popconfirm>
              </div>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </a-collapse-panel>
    </a-collapse>
    <div class="footer">
      <a-button icon="calculator" type="primary" :disabled="btnDisabled()" @click="buySignUp()">{{ matchInfo.signCostStatus === 'FREE' ? '该赛事免报名费' : (btnDisabled() ? '没有需缴费的队员' : '缴纳报名费') }}</a-button>
    </div>
    <SignupPayModelData ref="signupPayModelData"/>
    <PayQrCode ref="payQrCode" @paySuccess="paySuccess"/>
  </a-spin>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
import store from '@/store'
import SignupPayModelData from '@comm/components/join/pay/SignupPayModelData'
import PayQrCode from '@comm/components/join/pay/PayQrCode'
const singleCombatColumns = [
  { title: '队员姓名', dataIndex: 'name', scopedSlots: { customRender: 'name' }, align: 'left' },
  { title: '报名费', dataIndex: 'signStatus', scopedSlots: { customRender: 'signStatus' }, align: 'center', width: '70%' },
  { title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' }, align: 'center', width: '10%' }
]
const teamCombatColumns = [
  { title: '队员姓名', dataIndex: 'name', scopedSlots: { customRender: 'name' }, align: 'left' },
  { title: '所在小队', dataIndex: 'teamNumber', scopedSlots: { customRender: 'teamNumber' }, align: 'center', width: '10%' },
  { title: '报名费', dataIndex: 'signStatus', scopedSlots: { customRender: 'signStatus' }, align: 'center', width: '30%' },
  { title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' }, align: 'center', width: '10%' }
]
export default {
  components: {
    SignupPayModelData,
    PayQrCode
  },
  data () {
    return {
      buyInsuranceBtnName: '选中项缴纳保险',
      loading: false,
      defaultHead: require('@comm/assets/join/photo.png'),
      emptyUser: require('@comm/assets/join/empty_user.png'),
      singleCombatColumns: singleCombatColumns,
      teamCombatColumns: teamCombatColumns,
      bxChecked: false,
      signUpData: null,
      matchInfo: store.getters['match/matchInfo'],
      matchFun,
      selectedCardIds: [],
      needPhonePlayers: []
    }
  },
  mounted () {
    this.queryData()
  },
  methods: {
    queryData (toNext) {
      this.loading = true
      let matchId = this.$route.query.matchId
      let agencyId = this.$route.query.agencyId
      let teamId = this.$route.query.teamId
      this.$api.join.querySmallBallPayList11(matchId, agencyId, teamId).then(res => {
        if (res.status === 0) {
          this.signUpData = res.data
          if (toNext) {
            this.$emit('paySuccess')
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取报名数据失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    // 删除参赛信息
    delPlayer (combat, player, index, combatIndex, groupIndex) {
      let params = {
        matchId: this.$route.query.matchId,
        combatId: combat.combatId,
        agencyId: this.$route.query.agencyId,
        combatDetailId: combat.combatDetailId,
        cardId: player.cardId,
        teamId: this.$route.query.teamId,
        teamNumber: player.teamNumber
      }
      this.loading = true
      this.$api.join.delSmallballJoinPlayer(params).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          combat.players.splice(index, 1)
          if (combat.players.length === 0) {
            this.signUpData.groups[groupIndex].combats.splice(combatIndex, 1)
          }
          if (this.signUpData.groups[groupIndex].combats.length === 0) {
            this.signUpData.groups.splice(groupIndex, 1)
          }
          this.$forceUpdate()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('删除失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    buySignUp () {
      // 获取已经勾选的要购买保险的队员
      let needBuy = this.createPostParams()
      if (needBuy.length === 0) {
        this.$message.error('没有需要缴纳报名费的队员')
        return
      }
      let params = {
        agencyId: this.$route.query.agencyId,
        players: needBuy,
        matchId: this.$route.query.matchId,
        payType: 'PC'
      }
      this.loading = true
      this.$api.join.createSignUpOrder(params).then(res => {
        if (res.status === 0) {
          this.$refs.payQrCode.show(res.data)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('报名订单创建失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    createPostParams () {
      let choiceParams = []
      this.signUpData.groups.forEach(group => {
        let combats = group.combats
        combats.forEach(combat => {
          let players = combat.players
          players.forEach(player => {
            if (player.signStatus == 0) {
              choiceParams.push({ cardId: player.cardId, combatDetailId: combat.combatDetailId, combatId: combat.combatId, teamId: this.$route.query.teamId })
            }
          })
        })
      })
      return choiceParams
    },
    paySuccess () {
      this.queryData(true)
    },
    getPayType () {
      switch (this.matchInfo.signCostStatus) {
        case 'FREE':
          return '收费模式：免报名费'
        case 'PEOPLECHARGE':
          return '收费模式：按首项 + 加项收费'
        case 'COMBOCHARGE':
          return '收费模式：按项目组合收费'
        case 'TEAMCHARGE':
          return '收费模式：按队伍收费'
        default:
          return '收费模式：未知'
      }
    },
    showModelData () {
      this.$refs.signupPayModelData.show()
    },
    btnDisabled () {
      if (this.signUpData == null) {
        return true
      }
      let needBuyPlayers = this.createPostParams()
      if (needBuyPlayers.length === 0) {
        return true
      }
      return false
    },
    unPayPlayerNumInGroup (group) {
      let combats = group.combats
      let playerNum = 0
      let that = this
      combats.forEach(combat => {
        playerNum += that.unPayPlayerNumInTeam(combat)
      })
      return playerNum
    },
    unPayPlayerNumInTeam (combat) {
      let playerNum = 0
      let players = combat.players
      let unPayPlayers = players.filter(player => player.signStatus === 0)
      playerNum += unPayPlayers.length
      return playerNum
    },
    payOver () {
      // 是否有参赛队员
      if (this.signUpData == null) {
        return {
          status: false,
          content: '暂无任何队员参赛，请先完成选手报名'
        }
      }
      // 如果不是免费模式，则判断是否所有的队员参加的所有项目都已经完成了缴费
      if (this.matchInfo.signCostStatus !== 'FREE') {
        let groups = this.signUpData.groups
        for (let i = 0; i < groups.length; i++) {
          let combats = groups[i].combats
          for (let j = 0; j < combats.length; j++) {
            let hasNoPayPlayer = combats[j].players.some(player => player.signStatus === 0)
            if (hasNoPayPlayer) {
              return {
                status: false,
                content: '还有队员未缴纳报名费，请先缴纳报名费！'
              }
            }
          }
        }
        return { status: true }
      }
      return { status: true }
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .ant-collapse-content-box {
    background: #fafafa;
  }
  .title {
    font-size: 19px;
    font-weight: bold;
  }
  .header {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .team {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        height: 30px;
        width: 30px;
        border-radius: 15px;
      }

      .teamName {
        font-size: 18px;
        font-weight: bold;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
  .player {
    img {
      height: 50px;
      width: 40px;
    }
    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }
  .btnContent {
    text-align: right;
    margin-top: 20px;
  }
  .footer {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    text-align: right;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    background: #fafafa;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/smallBall/SignUpAmount.vue